import {
  useTranslate,
  IResourceComponentsProps,
  useShow,
} from "@pankod/refine-core";
import { Show, Typography } from "@pankod/refine-antd";

import { IAppVersion } from "interfaces";

const { Title, Text } = Typography;

export const AppVersionShow: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();

  const { queryResult } = useShow<IAppVersion>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>{t("app-version.fields.version")}</Title>
      <Text>{record?.version}</Text>
    </Show>
  );
};
